var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7999 17.4942V0.975342L12.7529 2.73711L7.27462 1.17189L0.199951 2.94056V19.4594L7.24702 17.6976L12.7253 19.2628L19.7999 17.4942ZM1.79995 17.4101V4.1898L7.24702 2.82803L12.7253 4.39325L18.2 3.02458V16.2449L12.7529 17.6067L7.27462 16.0415L1.79995 17.4101ZM8.06094 3.95654V14.9131H6.46094V3.95654H8.06094ZM11.939 16.4783V5.52173H13.539V16.4783H11.939Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.9919967b1e0dd4e959bb275f12d0735e.svg";
export { ForwardRef as ReactComponent };